import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";

const Courses = () => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 1024
  );

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerWidth < 1024);

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px",
    transition: "0.3s",
  };

  const iconStyle = {
    fontSize: "36px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const courseCards = [
    {
      title: "Test Schedule",
      description:
        "View your upcoming test schedule.",
      icon: "fa-calendar-alt",
      color: "#2563EB",
      link: "/test-schedule",
    },

    {
      title: "Course Materials",
      description:
        "Access your course materials and resources.",
      icon: "fa-book-open",
      color: "#2563EB",
      link: "/course-materials",
    },

    {
      title: "Assignments",
      description:
        "View and submit your assignments.",
      icon: "fa-tasks",
      color: "#FBBF24",
      link: "/assignments",
    },

    {
      title: "Homework",
      description:
        "Check your homework for each subject.",
      icon: "fa-pencil-alt",
      color: "#10B981",
      link: "/homework",
    },

    {
      title: "Student Attendance",
      description:
        "View your attendance records.",
      icon: "fa-user-check",
      color: "#8B5CF6",
      link: "/student-attendance",
    },

    {
      title: "Pending Homework",
      description:
        "Select students who didn't complete today's homework.",
      icon: "fa-book-reader",
      color: "#EF4444",
      link: "/homeworkNotCompleted",
    },

    // =====================================
    // MY CLASS
    // =====================================

    {
      title: "My Class",
      description:
        "Check your class students' Homework and Notebook reports.",
      icon: "fa-school",
      color: "#2563EB",
      link: "/my-class",
    },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">

        <div
          className={`grid gap-6 ${
            isMobile
              ? "grid-cols-1"
              : "sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {courseCards.map(
            (course, idx) => (
              <Link
                to={course.link}
                key={idx}
              >
                <div
                  style={cardStyle}
                  className="hover:scale-[1.02] transition"
                >
                  <i
                    className={`fas ${course.icon}`}
                    style={{
                      ...iconStyle,
                      color: course.color,
                    }}
                  ></i>

                  <div>
                    <h2 style={heading}>
                      {course.title}
                    </h2>

                    <p style={subText}>
                      {course.description}
                    </p>
                  </div>
                </div>
              </Link>
            )
          )}
        </div>

      </div>
    </div>
  );
};

export default Courses;